import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function CommissionModal() {
  const { schemeId } = useParams();
  const API = "/api/v1/commission_slab";

  const emptyRow = {
    service: "",
    type: "",
    start: "",
    end: "",
    merchantRate: "",
    distributorRate: "",
    gst: 18,
    status:"",
  };

  const [rows, setRows] = useState([emptyRow]);
  const [commissionList, setCommissionList] = useState([]);

  // ---------- EDIT FIELDS ----------
  const [editData, setEditData] = useState(null);

  const openEditModal = (item) => {
    setEditData({
      id: item.id,
      service: item.service,
      type: item.commission_type,
      start: item.start,
      end: item.end,
      merchantRate: item.merchant_rate,
      distributorRate: item.distributor_rate,
      gst: item.gst_percent,
      status:item.status,
    });
  };

  // -------------------------
  // Load Commissions
  // -------------------------
  const loadCommissions = async () => {
    try {
      const res = await authFetch(`${API}/list/${schemeId}`);
      const data = await res.json();

      // setCommissionList(data.data || []);
      setCommissionList(data || []);
    } catch (error) {
      console.log("Fetch error:", error);
    }
  };

  useEffect(() => {
    loadCommissions();
  }, [schemeId]);

  // -------------------------
  // Add Row
  // -------------------------
  const addRow = () => {
    setRows([...rows, { ...emptyRow }]);
  };

  // -------------------------
  // Delete Row
  // -------------------------
  const deleteRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  // -------------------------
  // Update Value
  // -------------------------
  const updateValue = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  // -------------------------
  // Create Commission
  // -------------------------
  const handleSubmit = async () => {
    try {
      for (const item of rows) {
        const payload = {
          scheme_id: schemeId,
          service: item.service,
          commission_type: item.type,
          start: Number(item.start),
          end: Number(item.end),
          merchant_rate: Number(item.merchantRate),
          distributor_rate: Number(item.distributorRate),
          gst_percent: Number(item.gst),
          status: item.status,
        };

        await authFetch(`${API}/create`, {
          method: "POST",
          body: JSON.stringify(payload),
        });
      }

      toastr.success("Commission Added Successfully!");
      loadCommissions();
      setRows([emptyRow]);
    } catch (error) {
      console.log("Save error:", error);
      toastr.error("Failed to save commission");
    }
  };

  // -------------------------
  // Edit Commission (PUT)
  // -------------------------
  const updateCommission = async () => {
    try {
      const payload = {
        service: editData.service,
        commission_type: editData.type,
        start: Number(editData.start),
        end: Number(editData.end),
        merchant_rate: Number(editData.merchantRate),
        distributor_rate: Number(editData.distributorRate),
        gst_percent: Number(editData.gst),
        status: editData.status,
      };

      await authFetch(`${API}/update/${editData.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });

      toastr.success("Commission Updated Successfully!");
      loadCommissions();
      setEditData(null);
    } catch (error) {
      toastr.error("Failed to update");
    }
  };

  // -------------------------
  // Delete Commission
  // -------------------------
  const deleteCommission = async (id) => {
    if (!window.confirm("Are you sure want to delete?")) return;

    try {
      await authFetch(`${API}/delete/${id}`, {
        method: "DELETE",
      });

      loadCommissions();
    } catch (error) {
      console.log("Delete Error:", error);
    }
  };

  // =======================
  // UI SECTION
  // =======================
  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">

              <div className="d-flex justify-content-between mb-3">
                <h4>Commission Manager</h4>

                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#commissionModal">
                  Add
                </button>
              </div>

              {/* ---------------- ADD MODAL ---------------- */}
              <div className="modal fade" id="commissionModal" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5>Add Commission</h5>
                      <button className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">

                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Service</th>
                            <th>Type</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Merchant Rate</th>
                            <th>Distributor</th>
                            <th>GST</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {rows.map((row, index) => (
                            <tr key={index}>
                              <td>
                                <select className="form-control" value={row.service}
                                  onChange={(e) => updateValue(index, "service", e.target.value)}>
                                  <option value="">Select</option>
                                  <option value="payin">Payin</option>
                                  <option value="payout">Payout</option>
                                  <option value="pan">PAN</option>
                                </select>
                              </td>

                              <td>
                                <select className="form-control" value={row.type}
                                  onChange={(e) => updateValue(index, "type", e.target.value)}>
                                  <option value="">Select</option>
                                  <option value="flat">Flat</option>
                                  <option value="percentage">Percentage</option>
                                </select>
                              </td>

                              <td>
                                <input type="number" className="form-control" value={row.start}
                                  onChange={(e) => updateValue(index, "start", e.target.value)} />
                              </td>

                              <td>
                                <input type="number" className="form-control" value={row.end}
                                  onChange={(e) => updateValue(index, "end", e.target.value)} />
                              </td>

                              <td>
                                <input className="form-control" value={row.merchantRate}
                                  onChange={(e) => updateValue(index, "merchantRate", e.target.value)} />
                              </td>

                              <td>
                                <input className="form-control" value={row.distributorRate}
                                  onChange={(e) => updateValue(index, "distributorRate", e.target.value)} />
                              </td>

                              <td>
                                <input type="number" className="form-control" value={row.gst}
                                  onChange={(e) => updateValue(index, "gst", e.target.value)} />
                              </td>

                              <td>
                                <select className="form-control" value={row.status}
                                  onChange={(e) => updateValue(index, "status", e.target.value)}>
                                  <option value="">Select</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              </td>

                              <td>
                                {rows.length > 1 && (
                                  <button className="btn btn-danger btn-sm"
                                    onClick={() => deleteRow(index)}>
                                    <i className="bx bx-trash"></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <button className="btn btn-primary" onClick={addRow}>+ Add More</button>
                    </div>

                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button className="btn btn-success" data-bs-dismiss="modal" onClick={handleSubmit}>Save</button>
                    </div>

                  </div>
                </div>
              </div>

              {/* ---------------- EDIT MODAL ---------------- */}
              {editData && (
                <div className="modal fade show" style={{ display: "block" }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                      <div className="modal-header">
                        <h5>Edit Commission</h5>
                        <button className="btn-close" onClick={() => setEditData(null)}></button>
                      </div>

                      <div className="modal-body">
                        <div className="row">

                          <div className="col-md-6">
                            <label>Service</label>
                            <select className="form-control" value={editData.service}
                              onChange={(e) => setEditData({ ...editData, service: e.target.value })}>
                              <option value="payin">Payin</option>
                              <option value="payout">Payout</option>
                              <option value="pan">PAN</option>
                            </select>
                          </div>

                          <div className="col-md-6">
                            <label>Type</label>
                            <select className="form-control" value={editData.type}
                              onChange={(e) => setEditData({ ...editData, type: e.target.value })}>
                              <option value="flat">Flat</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>

                          <div className="col-md-6 mt-3">
                            <label>Start</label>
                            <input type="number" className="form-control" value={editData.start}
                              onChange={(e) => setEditData({ ...editData, start: e.target.value })} />
                          </div>

                          <div className="col-md-6 mt-3">
                            <label>End</label>
                            <input type="number" className="form-control" value={editData.end}
                              onChange={(e) => setEditData({ ...editData, end: e.target.value })} />
                          </div>

                          <div className="col-md-6 mt-3">
                            <label>Merchant Rate</label>
                            <input className="form-control" value={editData.merchantRate}
                              onChange={(e) => setEditData({ ...editData, merchantRate: e.target.value })} />
                          </div>

                          <div className="col-md-6 mt-3">
                            <label>Distributor Rate</label>
                            <input className="form-control" value={editData.distributorRate}
                              onChange={(e) => setEditData({ ...editData, distributorRate: e.target.value })} />
                          </div>

                          <div className="col-md-6 mt-3">
                            <label>GST</label>
                            <input type="number" className="form-control" value={editData.gst}
                              onChange={(e) => setEditData({ ...editData, gst: e.target.value })} />
                          </div>

                          <div className="col-md-6">
                            <label>Status</label>
                            <select className="form-control" value={editData.status}
                              onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>

                        </div>
                      </div>

                      <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setEditData(null)}>Close</button>
                        <button className="btn btn-success" onClick={updateCommission}>Update</button>
                      </div>

                    </div>
                  </div>
                </div>
              )}

              {/* ---------------- TABLE ---------------- */}
              <div className="table-responsive mt-3">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Service</th>
                      <th>Type</th>
                      <th>Start</th>
                      <th>End</th>
                      <th>Merchant Rate</th>
                      <th>Distributor</th>
                      <th>GST</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {commissionList.length === 0 ? (
                      <tr><td colSpan="8" className="text-center">No Commission Found</td></tr>
                    ) : (
                      commissionList.map((c, i) => (
                        <tr key={i}>
                          <td>{c.service}</td>
                          <td>{c.commission_type}</td>
                          <td>{c.start}</td>
                          <td>{c.end}</td>
                          <td>{c.merchant_rate}</td>
                          <td>{c.distributor_rate}</td>
                          <td>{c.gst_percent}</td>
                          <td>{c.status}</td>

                          <td>
                            <button className="btn btn-sm btn-warning me-2"
                              onClick={() => openEditModal(c)}>
                              Edit
                            </button>

                            <button className="btn btn-sm btn-danger"
                              onClick={() => deleteCommission(c.id)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommissionModal;
